/** Normalize deposit limit period for form select values. */
export const toUkDepositPeriod = (period = "") => {
  const map = {
    daily: "1day",
    weekly: "7days",
    monthly: "30days",
    "1day": "1day",
    "7days": "7days",
    "30days": "30days",
    "7day": "7days",
    "30day": "30days",
  };
  return map[String(period).toLowerCase()] || period;
};

export const toCalendarDepositPeriod = (period = "") => {
  const map = {
    daily: "daily",
    weekly: "weekly",
    monthly: "monthly",
    "1day": "daily",
    "7days": "weekly",
    "30days": "monthly",
    "7day": "weekly",
    "30day": "monthly",
  };
  return map[String(period).toLowerCase()] || period;
};

export const normalizeDepositPeriodForForm = (period, isUk) =>
  isUk ? toUkDepositPeriod(period) : toCalendarDepositPeriod(period);
